import { isNil } from 'lodash-es'
import { useEffect, useState } from 'react'
import { isTrackingDisabled } from 'lib/tracking/segment'

const POLL_INTERVAL_MS = 200
const POLL_TIMEOUT_MS = 15_000

/**
 * Segment loads Intercom as a device-mode destination, so the SDK can land while `analytics.ready()`
 * is still pending on an unrelated destination. Waiting on that promise leaves the launcher hidden
 * even though Intercom already works, so poll `window.Intercom` itself.
 */
export const useIntercomAvailable = (): boolean => {
  const [isIntercomAvailable, setIntercomAvailable] = useState(isTrackingDisabled() ? false : !isNil(window.Intercom))

  useEffect(() => {
    if (isIntercomAvailable || isTrackingDisabled()) {
      return
    }

    const intervalId = setInterval(() => {
      if (!isNil(window.Intercom)) {
        clearInterval(intervalId)
        setIntercomAvailable(true)
      }
    }, POLL_INTERVAL_MS)

    const timeoutId = setTimeout(() => clearInterval(intervalId), POLL_TIMEOUT_MS)

    return () => {
      clearInterval(intervalId)
      clearTimeout(timeoutId)
    }
  }, [isIntercomAvailable])

  return isIntercomAvailable
}
